import { useMemo } from "react";
export function calcExpirationDate(
  dateStr?: string,
  frequency?: string
): string {
  if (!dateStr || !frequency) return "";

  const d = new Date(dateStr);
  const f = frequency.toLowerCase();

  if (f === "monthly" || f === "month") d.setMonth(d.getMonth() + 1);
  else if (f === "quarterly" || f === "quarter") d.setMonth(d.getMonth() + 3);
  else if (f.includes("half")) d.setMonth(d.getMonth() + 6);
  else if (f === "yearly" || f === "year") d.setFullYear(d.getFullYear() + 1);
  else return "";

  return d.toISOString().split("T")[0];
}

type Amount = string | number | null | undefined;

export const useAfterDiscount = (total: Amount, discount: Amount): string => {
  return useMemo(() => {
    const totalNum =
      typeof total === "string"
        ? Number.parseFloat(total)
        : total == null
        ? 0
        : Number(total);

    const discountNum =
      typeof discount === "string"
        ? Number.parseFloat(discount)
        : discount == null
        ? 0
        : Number(discount);

    if (!Number.isFinite(totalNum) || !Number.isFinite(discountNum)) {
      return "0.00";
    }

    const discountAmount = (totalNum * discountNum) / 100;
    const finalAmount = totalNum - discountAmount;

    return finalAmount.toFixed(2);
  }, [total, discount]);
};
